/** Encodes bytes as unpadded base64url (RFC 4648 §5), the alphabet RFC 7636 requires. */
function toBase64Url(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
}

function randomBase64Url(byteLength: number): string {
  return toBase64Url(crypto.getRandomValues(new Uint8Array(byteLength)));
}

/** RFC 7636 §4.1 `code_verifier`: 32 random bytes → 43 base64url characters. */
export const generateCodeVerifier = (): string => randomBase64Url(32);

/** Opaque anti-CSRF `state` echoed back by `/authorize` (RFC 6749 §10.12). */
export const generateState = (): string => randomBase64Url(16);

/** RFC 7636 §4.2 S256: `BASE64URL(SHA256(ASCII(code_verifier)))`. */
export async function deriveCodeChallenge(codeVerifier: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
  return toBase64Url(new Uint8Array(digest));
}
